<div *ngIf="!updating && !updatingError">
	<h4>Review and accept lender field changes</h4>

	<div class="mt-5 bg-grey-lightest text-grey-darker rounded-2xl flex p-5">
		<div class="flex mr-5 justify-center items-center">
			<app-icon [icon]="ICON.INFO"></app-icon>
		</div>
		<div class="text-sm">
			<p>
				The following changes have been made by the lender. To accept and apply
				these changes in Closer, click
				<span class="font-bold">Accept and continue</span>.
			</p>
			<p>
				To decline a change to the fields shared with the lender, deselect the
				checkbox next to the respective field.
			</p>
		</div>
	</div>

	<div class="mt-10" *ngIf="!loading && !error">
		<div class="flex flex-1">
			<div class="w-5/12"></div>
			<div class="w-3/12 flex justify-center">
				<div class="w-28">
					<img src="/assets/images/integrations/fct-logo.svg" />
				</div>
			</div>
			<div class="w-1/12"></div>
			<div class="w-3/12 flex justify-center">
				<div class="w-36">
					<img src="/assets/images/closer-logo.svg" />
				</div>
			</div>
		</div>
		<div
			*ngFor="let amendment of amendments"
			class="flex px-3 mt-3 bg-grey-lightest rounded-md py-2 items-center"
		>
			<div class="flex w-5/12">
				<app-checkbox
					type="clear"
					[(ngModel)]="amendment.override"
					[disabled]="!amendment.allowedToOverride"
				>
					<div class="flex flex-col">
						<span>{{ amendment.amendment.label }}</span>
						<span *ngIf="amendment?.extraLabel" class="text-sm"
							>({{ amendment.extraLabel }})</span
						>
					</div>
				</app-checkbox>
			</div>
			<div class="w-3/12 flex justify-center text-bold">
				<span *ngIf="amendment?.action === 'modify'">{{
					amendment.newValue
				}}</span>
				<span
					*ngIf="amendment?.action === 'remove'"
					[ngClass]="{
						'text-red-dark line-through': !amendment?.amendment?.newValue,
					}"
					>{{ amendment.previousValue }}</span
				>
				<span *ngIf="amendment?.action === 'add'" class="text-green">{{
					amendment?.amendment?.newValue?.length > 0
						? amendment?.amendment?.newValue
						: 'New'
				}}</span>
			</div>
			<div class="w-1/12 flex justify-center">
				<app-checkbox
					type="toggle"
					[icon]="ICON.OVERRIDE"
					[(ngModel)]="amendment.override"
					[disabled]="!amendment.allowedToOverride"
				></app-checkbox>
			</div>
			<div class="w-3/12 flex justify-center text-bold">
				<div>
					<span
						*ngIf="amendment?.previousValue?.length > 0"
						[ngClass]="{
							'text-red-dark line-through': amendment.action === 'remove',
						}"
					>
						{{ amendment?.previousValue }}
					</span>
				</div>
			</div>
		</div>
		<div class="flex flex-1 justify-end mt-10">
			<app-button btn="tertiary" size="small" (click)="skip()">Skip</app-button>
			<app-button class="ml-3" size="small" (click)="continue()"
				>Continue</app-button
			>
		</div>
	</div>

	<div
		*ngIf="loading"
		class="flex flex-1 justify-center items-center mt-20 mb-20"
	>
		<app-icon [icon]="ICON.LOADING" [spin]="true"></app-icon
		><span class="ml-2">Loading</span>
	</div>

	<div *ngIf="error">
		<p>Unable to fetch the ammendments from LLC.</p>
		<p>
			Please try again or if the problem continues reach out to one of our
			technical agents for assistance.
		</p>
	</div>
</div>
<div *ngIf="updating" class="flex flex-col justify-center items-center">
	<app-icon [icon]="ICON.LOADING" [spin]="true"></app-icon>
	<span class="ml-3">Applying amendments</span>
</div>
<div *ngIf="updatingError" class="flex flex-col justify-center items-center">
	<div *ngIf="invalidMappingsString" class="text-center">
		<p>
			We have been unable to map the following amendments:
			<span class="font-bold">{{ invalidMappingsString }}</span
			>.
		</p>
		<p>
			Please reach out to us at Closer and we will look into this immediately.
		</p>
	</div>
	<div *ngIf="!invalidMappingsString" class="flex-col items-center">
		<p>
			Uh oh! Looks like something unexpected happened when applying the
			amendments.
		</p>
		<app-button size="small" class="mt-5" (click)="continue()"
			>Retry applying amendments</app-button
		>
	</div>
</div>
